import { userDetailsApi1 } from '@subaio/api-specs'

import { asContainer } from 'lib/container'

import { OpenApi } from 'components/OpenApi'

type State = {}

export const container = asContainer<State>()({
	path: '/apis/user-details/v1',
	title: 'User Details API',
	authentication: { type: 'public' },
	Running: ({ statuspageApi }) => <OpenApi apiDocument={userDetailsApi1} statuspageApi={statuspageApi} />,
})
